import { WorkSchedule } from './WorkSchedule.main';

export { WorkSchedule };
